var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZaibukas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.836,
    height: 23.639,
    viewBox: "0 0 11.836 23.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_274525",
    "data-name": "Group 274525",
    transform: "translate(-209.061 -190.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274520",
    "data-name": "Group 274520",
    transform: "translate(209.061 190.85)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274518",
    "data-name": "Group 274518",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37519",
    "data-name": "Path 37519",
    d: "M211.633,219.316l.03-10.22-2.6-1.5,4.13-7.682,1.108-2.058-.058,3.05-.132,6.813,3.041,1.888Z",
    transform: "translate(-209.061 -197.855)",
    fill: "#6c8bf5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274519",
    "data-name": "Group 274519",
    transform: "translate(2.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37520",
    "data-name": "Path 37520",
    d: "M226.6,202.6l-5.515,9.71-3.75,2.18,5.517-9.71-3.041-1.888.132-6.813.058-3.05,3.748-2.178-.1,5.282-.088,4.579Z",
    transform: "translate(-217.331 -190.85)",
    fill: "#1e2042"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaibukas);
export default __webpack_public_path__ + "static/media/zaibukas.28a7370057deb788db2f970116ab126d.svg";
export { ForwardRef as ReactComponent };